import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import trim from 'lodash/trim';
import { emailValidator } from '../../helpers/validators';
import { InputLabel, InputText, EmailChangeBtn, ChangeButton, CancelButton } from './styled';
import { updateUserEmail } from '../../helpers/userinfoHelper';
import { authManager } from '../../helpers/managers';
import Loading from '../../components/Loading';

class UserEmail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      updating: false,
      oldEmail: '',
      newEmail: '',
      newEmail2: '',
      currentPassword: '',
      error: '',
      enteredPassword: false,
      enteredEmail: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { oldEmail = '' } = prevState;
    const { email = '' } = nextProps;
    if (isEmpty(oldEmail) || !isEqual(email, oldEmail)) {
      return {
        oldEmail: email,
      };
    }
    return null;
  }

  onInputStateChange = statekey => {
    return e => {
      const value = e.target.value;

      const error = this.getErrorForInput(statekey, value);

      this.setState({
        error,
        [statekey]: trim(value),
      });
    };
  };

  getErrorForInput = (statekey, value) => {
    let error = '';
    switch (statekey) {
      case 'newEmail':
        error = this.hasErrorEmail(value, this.state.newEmail2);
        if (!this.state.enteredEmail && !isEmpty(error)) {
          this.setState({
            enteredEmail: true,
          });
        }
        break;
      case 'newEmail2':
        error = this.hasErrorEmail(value, this.state.newEmail);
        if (!this.state.enteredEmail && !isEmpty(error)) {
          this.setState({
            enteredEmail: true,
          });
        }
        break;
      case 'currentPassword':
        error = this.hasErrorPassword(value);
        if (!this.state.enteredPassword && !isEmpty(error)) {
          this.setState({
            enteredPassword: true,
          });
        }
        break;
    }
    return error;
  };

  hasErrorPassword = password => {
    return isEmpty(password) ? 'The password cannot be empty.' : '';
  };

  hasErrorEmail = (email = '', email2 = '') => {
    const { oldEmail } = this.state;

    let error = '';
    if (isEmpty(email)) {
      error = 'New email cannot be empty.';
    } else if (!emailValidator(email)) {
      error = 'Please enter a valid new email address';
    } else if (isEqual(email, oldEmail)) {
      error = 'The new email address cannot be the same as the old one.';
    } else if ((!isEmpty(email) || !isEmpty(email2)) && !isEqual(email, email2)) {
      error = 'Please make sure you enter the same new email twice.';
    }
    return error;
  };

  showModal = (modalOpen = false) => {
    this.setState({
      modalOpen,
    });
  };

  onModalClose = () => {
    this.setState({
      updating: false,
      error: '',
      newEmail: '',
      newEmail2: '',
      enteredEmail: false,
      enteredPassword: false,
    });
    this.showModal(false);
  };

  showChangeDialog = () => {
    this.showModal(true);
  };

  submitEmail = () => {
    this.setState(
      {
        updating: true,
      },
      async () => {
        try {
          const { userId, email, onEmailChange } = this.props;
          const { newEmail, newEmail2, currentPassword } = this.state;

          const error =
            this.hasErrorEmail(newEmail, newEmail2) || this.hasErrorPassword(currentPassword) || '';
          if (!isEmpty(error)) {
            throw new Error(error);
          }

          try {
            // check current password
            await authManager.checkPassword(email, currentPassword);
            await updateUserEmail(userId, newEmail);

            this.setState(
              {
                updating: false,
                modalOpen: false,
                oldEmail: newEmail,
                newEmail: '',
                newEmail2: '',
                enteredEmail: false,
                enteredPassword: false,
              },
              onEmailChange
            );
          } catch (err) {
            const { message = '' } = err;
            if (!isEmpty(message)) {
              throw new Error(message);
            }

            console.log('Error while updating email: ', JSON.stringify(err));
            throw new Error('There is an error while updating email. Please try again later.');
          }
        } catch (e) {
          this.setState({
            updating: false,
            error: e.message,
          });
        }
      }
    );
  };

  renderEmailDialog() {
    const {
      modalOpen,
      updating,
      oldEmail,
      newEmail,
      newEmail2,
      currentPassword,
      error,
      enteredEmail,
      enteredPassword,
    } = this.state;

    const renderUpdateBtn = () => {
      const btnContent = updating ? (
        <Loading
          text="PROCESSING"
          type="circle"
          align="center"
          size={25}
          fontSize={1.4}
          color="#fff"
          fill="#fff"
          textStyle={{ margin: '0 5px' }}
        />
      ) : (
        'SUBMIT'
      );

      return (
        <ChangeButton
          onClick={this.submitEmail}
          disabled={updating}
          className={`btn text-white text-medium ${updating ? 'disabled' : ''}`}>
          {btnContent}
        </ChangeButton>
      );
    };

    return (
      <Dialog
        title="Change Email"
        actions={[
          <CancelButton
            disabled={updating}
            onClick={this.onModalClose}
            className="btn text-medium margin-two-right naked">
            CANCEL
          </CancelButton>,
          renderUpdateBtn(),
        ]}
        modal={updating}
        open={modalOpen}
        onRequestClose={this.onModalClose}
        contentStyle={{ width: '95%', maxWidth: 560, transform: 'translate(0px, 15px)' }}
        bodyStyle={{ overflowY: 'auto' }}
        actionsContainerStyle={{
          padding: '20px 24px',
          border: '1px solid #f6f6f6',
        }}
        autoScrollBodyContent>
        <div className="row padding-five-top">
          <div className="col-lg-12 col-md-12 col-xs-12">
            <div className="alert alert-warning text-medium" role="alert">
              Hint: The modified email will also become the login for the application and will be
              used to recover the password.
            </div>
          </div>
        </div>
        {!isEmpty(error) && (
          <div className="row">
            <div className="col-lg-12 col-md-12 col-xs-12">
              <div className="alert alert-danger text-medium" role="alert">
                {error}
              </div>
            </div>
          </div>
        )}
        <div className="row margin-five-bottom">
          <div className="col-lg-12 col-md-12 col-xs-12">
            <InputLabel>Current email</InputLabel>
            <InputText type="email" readonly disabled defaultValue={oldEmail} />
          </div>
        </div>
        <div className="row margin-five-bottom">
          <div className="col-lg-12 col-md-12 col-xs-12">
            <InputLabel>Current password</InputLabel>
            <InputText
              type="password"
              onChange={this.onInputStateChange('currentPassword')}
              defaultValue={currentPassword}
              errored={enteredPassword && this.hasErrorPassword(currentPassword)}
            />
          </div>
        </div>
        <div className="row margin-five-bottom">
          <div className="col-lg-12 col-md-12 col-xs-12">
            <InputLabel>New Email</InputLabel>
            <InputText
              type="email"
              onChange={this.onInputStateChange('newEmail')}
              defaultValue={newEmail}
              errored={enteredEmail && this.hasErrorEmail(newEmail, newEmail2)}
            />
          </div>
        </div>
        <div className="row margin-five-bottom">
          <div className="col-lg-12 col-md-12 col-xs-12">
            <InputLabel>Re-enter new email</InputLabel>
            <InputText
              type="email"
              onChange={this.onInputStateChange('newEmail2')}
              defaultValue={newEmail2}
              errored={enteredEmail && this.hasErrorEmail(newEmail2, newEmail)}
            />
          </div>
        </div>
      </Dialog>
    );
  }

  render() {
    return (
      <React.Fragment>
        <EmailChangeBtn onClick={this.showChangeDialog}>Update Email</EmailChangeBtn>
        {this.renderEmailDialog()}
      </React.Fragment>
    );
  }
}

UserEmail.propTypes = {
  userId: PropTypes.string,
  email: PropTypes.string,
  onEmailChange: PropTypes.func,
};

UserEmail.defaultProps = {
  userId: '',
  email: '',
  onEmailChange: () => {},
};

export default UserEmail;
